import React, { useState, useEffect } from 'react';
import './AddressForm.css';
import toast from 'react-hot-toast';

const AddressForm = ({ initialData, onSubmit, onCancel }) => {
  const [form, setForm] = useState({
    name: '', phone: '', addressLine1: '', addressLine2: '',
    city: '', state: '', pincode: '', isDefault: false
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      setForm(initialData);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : value
    }));

    if (name === 'pincode' && value.length === 6) {
      fetchPincodeDetails(value);
    }
  };

  const fetchPincodeDetails = async (pincode) => {
    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = await res.json();
      if (data && data[0] && data[0].Status === 'Success') {
        const postOffice = data[0].PostOffice[0];
        setForm(f => ({
          ...f,
          city: postOffice.District,
          state: postOffice.State
        }));
      }
    } catch (err) {
      console.error('Failed to fetch pincode details');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.phone.length !== 10) {
      toast.error('Phone number must be 10 digits');
      return;
    }
    if (form.pincode.length !== 6) {
      toast.error('Pincode must be 6 digits');
      return;
    }
    setLoading(true);
    await onSubmit(form);
    setLoading(false);
  };

  return (
    <div className="address-form-overlay">
      <div className="address-form-modal">
        <h3>{initialData ? 'Edit Address' : 'Add New Address'}</h3>
        <form onSubmit={handleSubmit} className="form-grid">
          <div className="form-group full-col">
            <label className="form-label">Full Name *</label>
            <input className="form-input" name="name" value={form.name} onChange={handleChange} required placeholder="Your full name" />
          </div>
          <div className="form-group full-col">
            <label className="form-label">Phone Number *</label>
            <input className="form-input" name="phone" value={form.phone} onChange={handleChange} required placeholder="10-digit mobile number" pattern="[0-9]{10}" />
          </div>
          <div className="form-group full-col">
            <label className="form-label">Address Line 1 *</label>
            <input className="form-input" name="addressLine1" value={form.addressLine1} onChange={handleChange} required placeholder="House no., Street, Area" />
          </div>
          <div className="form-group full-col">
            <label className="form-label">Address Line 2</label>
            <input className="form-input" name="addressLine2" value={form.addressLine2} onChange={handleChange} placeholder="Landmark (optional)" />
          </div>
          <div className="form-group">
            <label className="form-label">Pincode *</label>
            <input className="form-input" name="pincode" value={form.pincode} onChange={handleChange} required placeholder="6-digit pincode" pattern="[0-9]{6}" />
          </div>
          <div className="form-group">
            <label className="form-label">City *</label>
            <input className="form-input" name="city" value={form.city} onChange={handleChange} required placeholder="City" />
          </div>
          <div className="form-group">
            <label className="form-label">State *</label>
            <input className="form-input" name="state" value={form.state} onChange={handleChange} required placeholder="State" />
          </div>
          <div className="form-group full-col checkbox-group">
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input type="checkbox" name="isDefault" checked={form.isDefault} onChange={handleChange} />
              Set as Default Address
            </label>
          </div>
          <div className="form-actions full-col" style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
            <button type="button" className="btn btn-outline" style={{ flex: 1 }} onClick={onCancel}>Cancel</button>
            <button type="submit" className="btn btn-primary" style={{ flex: 1 }} disabled={loading}>
              {loading ? 'Saving...' : 'Save Address'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddressForm;
